import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { useNavigate } from '@lib/react-router-dom'

import { Body1, Title1 } from '@ui/Typography'
import { Button } from '@ui/components/Button'
import { TableNoResults } from '@ui/v2/Table/Table'

import { CommonPaths } from '@utils/path-common'

import { Box } from '@shared/components/Box'

interface CreateTradingAccountCTAProps {
  createTradingAccountPath: CommonPaths.NewLiveTradingAccount | CommonPaths.NewDemoTradingAccount
}

export const CreateTradingAccountCTA: FC<CreateTradingAccountCTAProps> = ({
  createTradingAccountPath,
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleCreateTA = () => {
    navigate(createTradingAccountPath)
  }

  return (
    <TableNoResults
      renderTitle={() => <Title1 semibold>{t('Start Trading')}</Title1>}
      content={
        <Body1 color='text-med-em'>
          {t('Create a trading account today in just a few steps.')}
        </Body1>
      }
    >
      <Box pt='x8'>
        <Button size='lg' variant='primary' fullWidth onClick={handleCreateTA}>
          {t('Create Trading Account')}
        </Button>
      </Box>
    </TableNoResults>
  )
}
